module.exports = __webpack_public_path__ + "img/contact.5ca97d19.png";